// Decides whether to reload for a newer frontend build.
//
// Compares the running build (`running`, frozen into this bundle at build time)
// against the deployed build (`deployed`, read from /version.json which ships
// with the bundle). If a newer version is deployed it reloads once — the guard
// (`reloadedForVersion` in the injected storage) stops it from reloading again
// if the reload didn't actually update us (e.g. a stale CDN still serving the
// old bundle), which is what used to cause an endless refresh loop.
//
// Dependencies are injected so this is a pure, unit-testable function.
export function reloadIfStale({ deployed, running, storage, reload }) {
    if (!deployed || String(deployed) === String(running)) return false
    if (storage.getItem('reloadedForVersion') === String(deployed)) return false
    storage.setItem('reloadedForVersion', String(deployed))
    reload()
    return true
}
